import Vue from "vue";
import Vuex from "vuex";
import createThrottledPersistedState from "../util/throttledPersistedState";
import createMutationsSharer from "vuex-shared-mutations";
import station from "./modules/station";
import user from "./modules/user";
import segment from "./modules/segment";
import line from "./modules/line";
import entity from "./modules/item";
import orer from "./modules/orer";
import ubs from "./modules/ubs";
import helper from "./modules/helper";
import position from "./modules/position";
import car from "./modules/car";
import seatMap from "./modules/seatMap";
// import zoneBasedPricing from "./modules/zoneBasedPricing";
import parkourBasedPricing from "./modules/parkourBasedPricing";
import timeSchedule from "./modules/timeSchedule";
import * as VueGoogleMaps from "vue2-google-maps";
import hardware from "./modules/hardware";
import itemGroup from "./modules/itemGroup";
import item from "./modules/item";
import itemProperty from "./modules/itemProperty";
import itemType from "./modules/itemType";
import itemGroupType from "./modules/itemGroupType";
import physicalProperties from "./modules/physicalProperties";
import gise from "./modules/gise";
import cabinClass from "./modules/cabinClass";
import bookingClass from "./modules/bookingClass";
import fareFamily from "./modules/fareFamily";
import pricing from "./modules/pricing";
import passengerType from "./modules/passengerType";
import mainUnit from "./modules/mainUnit";
import additionalService from "./modules/additionalService";
import additionalServiceType from "./modules/additionalServiceType";
import additionalServicePricing from "./modules/additionalServicePricing";
import resourceGroup from "./modules/resourceGroup";
import resource from "./modules/resource";
import role from "./modules/role";
import roleGroup from "./modules/roleGroup";
import trainSet from "./modules/trainSet";
import trainConnecting from "./modules/trainConnecting";
import schedule from "./modules/schedule";
import sefer from "./modules/sefer";
import kilometricPricing from "./modules/kilometricPricing";
import agent from "./modules/agent";
import commission from "./modules/commission";
import closeAccount from "./modules/closeAccount";
import closeAccountApprove from "./modules/closeAccountApprove";
import kkyAccountTransfer from "./modules/kkyAccountTransfer";
import boxOffice from "./modules/boxOffice";
import carGroup from "./modules/carGroup";
import quota from "./modules/quota";
import saleChannel from "./modules/saleChannel";
import helperRequest from "./modules/helperRequest";
import payment from "./modules/payment";
import subscription from "./modules/subscription";
import train from "./modules/train";
import discountPackage from "./modules/discountPackage";
import specialServiceRequestCategory from "./modules/specialServiceRequestCategory";
import specialServiceRequest from "./modules/specialServiceRequest";
import additionalServiceKilometricPricing from "./modules/additionalServiceKilometricPricing";
import additionalServiceParkourBasedPricings from "./modules/additionalServiceParkourBasedPricings";
import ssrKilometricPricing from "./modules/ssrKilometricPricing";
import ssrParkourBasedPricings from "./modules/ssrParkourBasedPricings";
import title from "./modules/title";
import report from "./modules/report";
import parameter from "./modules/parameter";
import trainScheduleParameter from "./modules/trainScheduleParameter";
import blacklist from "./modules/blacklist";
import notification from "./modules/notification";
import information from "./modules/information";
import help from "./modules/help";
import trainRegion from "./modules/trainRegion";
import appVersion from "./modules/appVersion";
import connectedTrainDiscount from "./modules/connectedTrainDiscount";
import interrailAndEurail from "./modules/interrailAndEurail";

import axios from "axios";

const AUTH_TOKEN = localStorage.getItem("AUTH_TOKEN") ? localStorage.getItem("AUTH_TOKEN") : null;
// const UNIT_ID = localStorage.getItem("UNIT_ID") ? localStorage.getItem("UNIT_ID") : null;

import { storeAuthTokens, clearAuthTokens } from "../util/authTokenStorage";
import { isCdnRequest, toPlainCdnRequest } from "../util/cdnRequest";

import VueAxios from "vue-axios";
import equivalentStation from "./modules/equivalentStation";
import trainWhereStation from "./modules/trainWhereStation";
import stationStatus from "./modules/stationStatus";
import stationType from "./modules/stationType";
import appConstants from "../plugins/appConstants";
import booking from "./modules/booking";
import announcement from "./modules/announcement";
import messageTranslation from "./modules/messageTranslation";
import parkourBasedPricings from "./modules/parkourBasedPricings";
import seatMapConnectingTemplate from "./modules/seatMapConnectingTemplate";
import customer from "./modules/customer";
import muhtira from "./modules/muhtira";
import militaryUnit from "./modules/militaryUnit";
import trainSetMapping from "./modules/trainSetMapping";
import intent from "./modules/intent";
import uiSettings from "./modules/uiSettings";
import lostProperty from "./modules/lostProperty";

Vue.use(VueAxios, axios);
Vue.use(Vuex);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCtdx80LXzPV-2RsOomXy3BHFHvV82rQv4",
    libraries: "places",
  },
});

const getDefaultState = () => {
  let state = {
    redirectPath: "",
    sessionWarningModalOpen: false,
  };
  state.environment = appConstants.environment;
  state.serviceUrl = appConstants.serviceUrl;
  state.mcServiceUrl = appConstants.mcServiceUrl;
  state.tmsServiceUrl = appConstants.tmsServiceUrl;
  state.tmsCdnServiceUrl = appConstants.tmsCdnServiceUrl;
  state.crsServiceUrl = appConstants.crsServiceUrl;
  state.poolExternalUrl = appConstants.poolExternalUrl;
  state.dynamicPricing = appConstants.dynamicPricing;
  return state;
};

// Satış akışı (gise, booking) window.name anahtarıyla sekmeye özel tutulur. localStorage'da durunca her yazma
// açık tüm sekmelere kopyalanıyordu; sessionStorage'da sekmeye özel kalır, sekme kapanınca silinir.
const TAB_MODULES = ["gise", "booking"];
const TAB_MUTATIONS = new Set([...Object.keys(gise.mutations), ...Object.keys(booking.mutations)]);
// BaseHeader'ın her saniye (sistem saati, gece yarısı bayrağı) ve fare hareketinde (son aktivite) yaptığı commit'ler ile
// BaseAlert'in geri sayım commit'leri kalıcı yazmayı tetiklemez, ertelenir.
const NOISY_MUTATIONS = ["setLastActivityTime", "setSystemDateNow", "setMidnightRefreshFlag", "setDismissCountDown"];
// item.itemsMap base64 koltuk ikonlarını tutar (~1,8 MB). Ana "vuex" anahtarında durunca her yazmayı bu kadar büyütüyordu;
// ayrı anahtarda tutulur ve yalnız değişince yazılır (fetchAndSetItemsMap doldurma bitince setItemsMap commit eder).
const ITEMS_MAP_PATH = "item.itemsMap";
const ITEMS_MAP_MUTATIONS = new Set(["setItemsMap", "setDefaultItemModule"]);

export const store = new Vuex.Store({
  plugins: [
    createThrottledPersistedState({
      omitPaths: [...TAB_MODULES, ITEMS_MAP_PATH],
      noisyMutations: NOISY_MUTATIONS,
      mutationFilter: (mutation) => !TAB_MUTATIONS.has(mutation.type),
    }),
    createThrottledPersistedState({
      key: "vuex-tab",
      storage: window.sessionStorage,
      paths: TAB_MODULES,
      mutationFilter: (mutation) => TAB_MUTATIONS.has(mutation.type),
    }),
    createThrottledPersistedState({
      key: "vuex-items",
      paths: [ITEMS_MAP_PATH],
      mutationFilter: (mutation) => ITEMS_MAP_MUTATIONS.has(mutation.type),
    }),
    createMutationsSharer({
      predicate: [
        "setUser",
        "setSelectedUserUnitId",
        "getSelectedUserUnitId",
        "setLoggedIn",
        "setLastActivityTime",
        "setUserPermissions",
        "setUserResources",
        "setCallCenterUCId",
      ],
    }),
  ],

  state: () => getDefaultState(),

  mutations: {
    setServiceUrl(state, serviceUrl) {
      state.serviceUrl = serviceUrl;
    },
    setMcServiceUrl(state, mcServiceUrl) {
      state.mcServiceUrl = mcServiceUrl;
    },
    setCrsServiceUrl(state, crsServiceUrl) {
      state.crsServiceUrl = crsServiceUrl;
    },
    setPoolExternalUrl(state, poolExternalUrl) {
      state.poolExternalUrl = poolExternalUrl;
    },
    setDynamicPricing(state, dynamicPricing) {
      state.dynamicPricing = dynamicPricing;
    },
    reloadState(state) {
      Object.assign(state, getDefaultState());
    },
    setRedirectPath(state, redirectPath) {
      Vue.set(state, "redirectPath", redirectPath);
    },
    setEnvironment(state, environment) {
      state.environment = environment;
    },
    resetStore(state) {
      let itemsMap = null;
      if (state.item && state.item.itemsMap) {
        itemsMap = state.item.itemsMap;
      }
      let newState = { ...getDefaultState(), item: { itemsMap } };
      state = newState;
    },
    setSessionWarningModalOpen(state, value) {
      state.sessionWarningModalOpen = value;
    },
  },

  getters: {
    getServiceUrl: (state) => {
      return state.serviceUrl;
    },
    getMcServiceUrl: (state) => {
      return state.mcServiceUrl;
    },
    getCrsServiceUrl: (state) => {
      return state.crsServiceUrl;
    },
    getTmsServiceUrl: (state) => {
      return state.tmsServiceUrl;
    },
    getTmsCdnServiceUrl: (state) => {
      return state.tmsCdnServiceUrl;
    },
    getPoolExternalUrl: (state) => {
      return state.poolExternalUrl;
    },
    getDynamicPricing: (state) => {
      return state.dynamicPricing;
    },
    getBasePath: (state) => {
      return state.basePath;
    },
    getRedirectPath: (state) => {
      return state.redirectPath;
    },
    getEnvironment: (state) => {
      return state.environment;
    },
    getSessionWarningModalOpen: (state) => state.sessionWarningModalOpen,
  },
  modules: {
    station,
    trainScheduleParameter,
    equivalentStation,
    trainWhereStation,
    user,
    segment,
    line,
    item,
    itemProperty,
    itemType,
    itemGroupType,
    orer,
    parkourBasedPricing,
    ubs,
    helper,
    position,
    car,
    seatMap,
    timeSchedule,
    hardware,
    itemGroup,
    physicalProperties,
    stationStatus,
    stationType,
    gise,
    cabinClass,
    bookingClass,
    fareFamily,
    pricing,
    passengerType,
    mainUnit,
    additionalService,
    additionalServiceType,
    additionalServicePricing,
    resourceGroup,
    resource,
    role,
    roleGroup,
    booking,
    trainSet,
    trainConnecting,
    schedule,
    sefer,
    announcement,
    messageTranslation,
    kilometricPricing,
    agent,
    commission,
    closeAccount,
    closeAccountApprove,
    kkyAccountTransfer,
    boxOffice,
    parkourBasedPricings,
    carGroup,
    helperRequest,
    seatMapConnectingTemplate,
    customer,
    quota,
    saleChannel,
    payment,
    subscription,
    train,
    discountPackage,
    specialServiceRequestCategory,
    specialServiceRequest,
    additionalServiceKilometricPricing,
    additionalServiceParkourBasedPricings,
    ssrKilometricPricing,
    ssrParkourBasedPricings,
    title,
    report,
    parameter,
    blacklist,
    notification,
    information,
    help,
    muhtira,
    militaryUnit,
    trainRegion,
    trainSetMapping,
    appVersion,
    connectedTrainDiscount,
    interrailAndEurail,
    intent,
    uiSettings,
    lostProperty,
  },
});

axios.defaults.params = {};
axios.defaults.params["environment"] = "dev";
//axios.defaults.params['userId'] = 1;
axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
// b2b yalnızca Türkçe; tarayıcı dili gönderilirse backend hata mesajlarını o dile çevirir.
axios.defaults.headers.common["Accept-Language"] = "tr";
if (store.getters.getSelectedUserUnitId) {
  axios.defaults.headers.common["unit-id"] = store.getters.getSelectedUserUnitId;
}
if (store.getters.getCallCenterUCId) {
  axios.defaults.headers.common["uc-id"] = store.getters.getCallCenterUCId;
}
let isSessionExpiredHandling = false;

const AUTH_ERROR_CODES = [601, 603, 632];
const ACCESS_TOKEN_REFRESH_BUFFER_MS = 60 * 1000;

function isLoginRequest(error) {
  const url = error.config && error.config.url;
  return url && url.includes("/user/login");
}

function isAuthTokenEndpoint(url) {
  return url && (url.includes("/user/login") || url.includes("/user/refresh"));
}

function isOnLoginPage() {
  return window.location.pathname === "/giris-yap";
}

// Ayni anda birden fazla istek access token'in suresinin dolduguna karar verirse
// tek bir refresh cagrisi paylasilir, her istek kendi refresh'ini tetiklemez.
let refreshPromise = null;

function refreshAccessToken() {
  const refreshToken = localStorage.getItem("REFRESH_TOKEN");
  if (!refreshToken) {
    return Promise.reject(new Error("No refresh token available"));
  }
  if (!refreshPromise) {
    refreshPromise = store
      .dispatch("refreshUserToken", { refreshToken })
      .then((response) => {
        storeAuthTokens(response);
        return response;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}

function handleSessionExpired() {
  if (isSessionExpiredHandling || isOnLoginPage()) {
    return;
  }
  isSessionExpiredHandling = true;

  clearAuthTokens();
  store.commit("setLoggedIn", false);
  store.commit("resetStore");

  store.commit("setDismissCountDown", 20);
  store.commit("setAlertText", "Oturum süresi dolmuş ya da token geçersiz. Lütfen tekrar giriş yapın.");
  store.commit("setAlertVariant", "warning");
  store.commit("setAlertTitle", "Oturum Süresi Doldu");
  store.commit("setAlertIcon", "warning");

  setTimeout(() => {
    window.location.href = window.location.origin + "/giris-yap";
  }, 2000);
}

// Seçili birimin satış kanalı; tanımsız ya da geçersizse gişe (3) ile devam edilir çünkü backend 0 değerinde hata veriyor.
// TODO: 1-10 aralığı kontrolü ve gişe varsayılanı geçici hotfix olarak eklendi.
//  Kalıcı çözümde backend salesChannel'ı unit'ten çözmeli (bkz. RailTicketCancellationHelper.findSalesChannelByUnitId kullanımı).
const DEFAULT_SALES_CHANNEL = 3;

function resolveSalesChannel() {
  const salesChannel = Number(store.getters.getUser?.userUnits?.find((unit) => unit.id === store.getters.getSelectedUserUnitId)?.salesChannel);
  return Number.isInteger(salesChannel) && salesChannel >= 1 && salesChannel <= 10 ? salesChannel : DEFAULT_SALES_CHANNEL;
}

// tms'te CSRF korumasi servisin tamaminda degil yalnizca bu state-changing endpoint'lerde acik
// (bkz. tms CsrfProtectionMatcher). Token GET /csrf ile alinir; cookie HttpOnly oldugu icin
// axios'un cookie okumaya dayanan otomatik XSRF davranisi kullanilamiyor, header elle ekleniyor.
const CSRF_PROTECTED_TMS_PATHS = [
  "/train/train-availability",
  "/inventory/find-seat-map-allocations",
  "/inventory/select-seat",
  "/inventory/check-seat-selection-prices",
];

let csrfTokenPromise = null;

function isCsrfProtectedRequest(config) {
  const tmsServiceUrl = store.getters.getTmsServiceUrl;
  if (!tmsServiceUrl || !config || !config.url) {
    return false;
  }
  return CSRF_PROTECTED_TMS_PATHS.some((path) => config.url === tmsServiceUrl + path);
}

function loadCsrfToken() {
  if (!csrfTokenPromise) {
    // withCredentials: cookie'nin tarayicida saklanip sonraki isteklerde geri gonderilmesi icin sart.
    csrfTokenPromise = axios
      .get(store.getters.getTmsServiceUrl + "/csrf", { withCredentials: true })
      // Servis CSRF'i kapaliysa 204 doner; bu durum da cache'lenir ki her istekte tekrar sorulmasin.
      .then((response) => response.data || null)
      .catch((error) => {
        csrfTokenPromise = null; // sonraki istekte yeniden denensin
        throw error;
      });
  }
  return csrfTokenPromise;
}

function withCsrfToken(config) {
  if (!isCsrfProtectedRequest(config)) {
    return config;
  }
  return loadCsrfToken()
    .then((csrf) => {
      if (csrf && csrf.headerName && csrf.token) {
        config.headers[csrf.headerName] = csrf.token;
        config.withCredentials = true;
      }
      return config;
    })
    .catch(() => config); // token alinamazsa istek token'siz gider, 403 donerse response interceptor yeniden dener
}

axios.interceptors.request.use((config) => {
  if (isCdnRequest(config, store.getters.getTmsCdnServiceUrl)) {
    return toPlainCdnRequest(config);
  }
  const unitId = store.getters.getSelectedUserUnitId;
  if (unitId) {
    config.headers["unit-id"] = unitId;
  }
  const ucId = store.getters.getCallCenterUCId;
  if (ucId) {
    config.headers["uc-id"] = ucId;
  }
  // İsteğin kendisi açıkça bir kanal verdiyse (ör. hts/check-tickets-new) ona dokunulmaz.
  if (config.headers["sales-channel"] === undefined) {
    config.headers["sales-channel"] = resolveSalesChannel();
  }

  const accessExpiresAt = Number(localStorage.getItem("ACCESS_EXPIRES_AT"));
  const hasRefreshToken = !!localStorage.getItem("REFRESH_TOKEN");
  const needsProactiveRefresh =
    !isAuthTokenEndpoint(config.url) && hasRefreshToken && accessExpiresAt && accessExpiresAt - Date.now() < ACCESS_TOKEN_REFRESH_BUFFER_MS;

  if (needsProactiveRefresh) {
    return refreshAccessToken()
      .then(() => {
        config.headers["Authorization"] = axios.defaults.headers.common["Authorization"];
        return withCsrfToken(config);
      })
      .catch(() => withCsrfToken(config)); // refresh basarisiz olursa istek eski token ile devam eder, 401 handler devreye girer
  }

  return withCsrfToken(config);
});
// Kilit hatasi 9 farkli workflow'dan gelebiliyor (bilet kesme, tren/sefer olusturma, kasa kapama,
// kayip esya eslestirme). Her biri icin ne yapilmasi gerektigi farkli oldugundan workflow adina gore
// ayri metin veriliyor; taninmayan bir workflow icin genel metne dusuluyor.
const WORKFLOW_LOCK_MESSAGES = {
  "crs-rail-issue-ticket": "Bu PNR için bilet kesme işlemi hâlâ sürüyor. Lütfen birkaç saniye bekleyip PNR'ı yeniden sorgulayınız; bilet kesilmiş olabilir.",
  "create-scheduled-trains": "Tren oluşturma işlemi hâlâ sürüyor. Lütfen tamamlanmasını bekleyip listeyi yenileyiniz.",
  "create-single-schedule-trains": "Tren oluşturma işlemi hâlâ sürüyor. Lütfen tamamlanmasını bekleyip listeyi yenileyiniz.",
  "create-trains-by-number-and-date": "Tren oluşturma işlemi hâlâ sürüyor. Lütfen tamamlanmasını bekleyip listeyi yenileyiniz.",
  "create-trains-by-type-and-date": "Tren oluşturma işlemi hâlâ sürüyor. Lütfen tamamlanmasını bekleyip listeyi yenileyiniz.",
  "create-schedule": "Bu sefer için kayıt işlemi hâlâ sürüyor. Lütfen tamamlanmasını bekleyip sayfayı yenileyiniz.",
  "close-accounting": "Bu kullanıcı için kasa kapama işlemi hâlâ sürüyor. Lütfen tamamlanmasını bekleyiniz.",
  "close-all-accounts": "Gün sonu kasa kapama işlemi sürüyor. Lütfen tamamlanmasını bekleyiniz.",
  "match-lost-property": "Bu kayıp eşya kaydı için eşleştirme işlemi hâlâ sürüyor. Lütfen tamamlanmasını bekleyiniz.",
  "subscription-purchase-create":
    "Bu yolcu için abonman satışı hâlâ sürüyor. Lütfen birkaç saniye bekleyip yolcunun paketlerini yeniden sorgulayınız; satış tamamlanmış olabilir.",
  "discount-package-purchase-create":
    "Bu yolcu için indirim paketi satışı hâlâ sürüyor. Lütfen birkaç saniye bekleyip yolcunun paketlerini yeniden sorgulayınız; satış tamamlanmış olabilir.",
};
const GENERIC_WORKFLOW_LOCK_MESSAGE = "Bu işlem için önceki talebiniz hâlâ sürüyor. Lütfen tamamlanmasını bekleyip sayfayı yenileyiniz.";

function workflowLockedMessage(message) {
  const workflowId = (message.match(/Cannot initiate the workflow ([^.\s]+)/) || [])[1];
  return WORKFLOW_LOCK_MESSAGES[workflowId] || GENERIC_WORKFLOW_LOCK_MESSAGE;
}

axios.interceptors.response.use(
  (response) => {
    if (response.data.accessToken) return response;
    return response;
  },
  (error) => {
    const resp = error.response;
    const data = resp && resp.data;
    const message = data && data.message;
    const config = error.config;

    const isAuthFailure =
      resp &&
      !isLoginRequest(error) &&
      (resp.status === 401 || (data && AUTH_ERROR_CODES.includes(data.code))) &&
      message !== "Access is denied";

    if (isAuthFailure) {
      const hasRefreshToken = !!localStorage.getItem("REFRESH_TOKEN");
      if (hasRefreshToken && config && !config._retriedAfterRefresh && !isAuthTokenEndpoint(config.url)) {
        config._retriedAfterRefresh = true;
        return refreshAccessToken()
          .then(() => {
            config.headers["Authorization"] = axios.defaults.headers.common["Authorization"];
            return axios(config);
          })
          .catch(() => {
            handleSessionExpired();
            return Promise.reject(error);
          });
      }
      handleSessionExpired();
      return Promise.reject(error);
    }

    // CSRF token'i eskimis olabilir (cookie suresi dolmus ya da servis yeniden baslamis).
    // Yetki reddi de 403 donduren icin "Access is denied" mesaji ayriliyor; o durumda tekrar denenmez.
    if (
      resp &&
      resp.status === 403 &&
      message !== "Access is denied" &&
      config &&
      !config._retriedAfterCsrf &&
      isCsrfProtectedRequest(config)
    ) {
      config._retriedAfterCsrf = true;
      csrfTokenPromise = null;
      return axios(config); // request interceptor yeni token'i ekler
    }

    if (message === "Access is denied") {
      window.location.href = window.location.origin + "/401";
    }
    if (message && message.includes("CLUSTER")) {
      error.response.data.message = "Sistem Hatası.";
    }
    if (message && message.includes("SOAP")) {
      error.response.data.message = "Servisten cevap alınamıyor. Lütfen daha sonra tekrar deneyiniz.";
    }
    // Loko workflow kilidi (loko-lib WorkflowManager, code 10000). Ayni is icin onceki calisma
    // henuz bitmeden ikinci istek gelmis demek. Backend mesaji teknik workflow adini iceriyor
    // ("Cannot initiate the workflow <id>. The workflow is locked."), kullaniciya bir sey ifade
    // etmiyor; workflow adina gore anlasilir bir metinle degistiriliyor.
    if (message && message.includes("The workflow is locked")) {
      error.response.data.message = workflowLockedMessage(message);
    }
    return Promise.reject(error);
  }
);
